import { ItemStatus } from "@focus/interfaces/lib/common/itemFetchStatus";
import { useEffect, useRef } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
export const createUseFetch = (fetcher, statePath, removePrevious = true) => (config) => {
    const status = useSelector((state) => fetcher.selectors.getStatus(statePath(state), config), shallowEqual);
    const error = useSelector((state) => fetcher.selectors.getItemError(statePath(state), config), shallowEqual);
    const value = useSelector((state) => fetcher.selectors.getItem(statePath(state), config), shallowEqual);
    const dispatch = useDispatch();
    const prevConfig = useRef(null);
    useEffect(() => {
        if (!value || removePrevious) {
            dispatch(fetcher.actions.fetchItem(config));
        }
        if (prevConfig.current && removePrevious) {
            dispatch(fetcher.actions.deleteItem(prevConfig.current));
        }
        prevConfig.current = config;
        return () => {
            removePrevious && dispatch(fetcher.actions.deleteItem(config));
        };
    }, [config]);
    return { status, error, value };
};
export const createUseFetches = (fetcher, statePath) => (configs) => {
    const statuses = useSelector((state) => configs.map((config) => fetcher.selectors.getStatus(statePath(state), config)), shallowEqual);
    const areReady = statuses.every((val) => val === ItemStatus.READY);
    const haveError = statuses.includes(ItemStatus.ERROR);
    const status = areReady
        ? ItemStatus.READY
        : haveError
            ? ItemStatus.ERROR
            : ItemStatus.PENDING;
    const errors = useSelector((state) => configs.map((config) => fetcher.selectors.getItemError(statePath(state), config)), shallowEqual);
    const values = useSelector((state) => configs.map((config) => fetcher.selectors.getItem(statePath(state), config)), shallowEqual);
    const dispatch = useDispatch();
    const prevConfigs = useRef(null);
    useEffect(() => {
        configs.forEach((config) => dispatch(fetcher.actions.fetchItem(config)));
        if (prevConfigs.current) {
            prevConfigs.current.forEach((prevConfig) => dispatch(fetcher.actions.deleteItem(prevConfig)));
        }
        prevConfigs.current = configs;
        return () => {
            configs.forEach((config) => dispatch(fetcher.actions.deleteItem(config)));
        };
    }, [configs]);
    return { status, errors, values };
};
export const createUseItem = (fetcher, statePath) => (config) => {
    const status = useSelector((state) => fetcher.selectors.getStatus(statePath(state), config), shallowEqual);
    const error = useSelector((state) => fetcher.selectors.getItemError(statePath(state), config), shallowEqual);
    const value = useSelector((state) => fetcher.selectors.getItem(statePath(state), config), shallowEqual);
    return { status, error, value };
};
//# sourceMappingURL=fetchHooks.js.map